import { CampaignBlocks, mapToCard, SessionState } from "@kvix/shared";
import { Container, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { motion, useTransform, useViewportScroll } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import { UpcomingSessionCard } from "../../Card";
import { Text } from "../../Primitives";
import { AdminFormInput } from "../admin";
import { AdminCampaignContentContext } from "../context/adminCampaignContentContext";
import { useRefScrollProgress } from "../utils/getRefScrollProgress";
import { useWindowSize } from "../utils/getWindowSize";
const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        paddingBottom: "120px",
        [theme.breakpoints.down("sm")]: {
            textAlign: "left"
        }
    },
    titleText: {
        padding: "120px 0 20px 0",
        [theme.breakpoints.down("sm")]: {
            wordBreak: "break-word",
            fontSize: "46px",
            lineHeight: "48px"
        }
    },
    bodyText: {
        paddingBottom: "40px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "16px",
            lineHeight: "24px",
            marginTop: "20px",
            paddingBottom: "60px"
        }
    },
    cardWrapper: {
        display: "flex",
        overflow: "hidden",
        width: "100%",
        maxWidth: "1256px"
    },
    motionDiv: {
        display: "flex"
    },
    card: {
        marginRight: "10px",
        pointerEvents: "none"
    },
    titlesBox: {
        display: "flex",
        justifyContent: "flex-end",
        textAlign: "start",
        flexDirection: "column"
    }
}));
export class AnimatedSessionsBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.AnimatedSessionsBlock,
            titles: [""],
            texts: [""],
            sessionIds: []
        };
        this.Render = (props) => {
            var _a;
            const { block } = props;
            const classes = useStyles();
            const { scrollY } = useViewportScroll();
            const sessionsOnClient = (_a = props.campaignContext) === null || _a === void 0 ? void 0 : _a.actions.useFetchUpcomingSessions(10);
            const theme = useTheme();
            const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
            const size = useWindowSize();
            const sessionBlockRef = useRef(null);
            const { start, end } = useRefScrollProgress(sessionBlockRef);
            const actualStart = start - size.height;
            const actualEnd = end - size.height;
            const [sessions, setSessions] = useState();
            const adminContent = useContext(AdminCampaignContentContext);
            const x = useTransform(scrollY, [actualStart + 400, end + 500], [0, -300]);
            const yHeader = useTransform(scrollY, [actualStart, actualEnd], [100, 0]);
            const opacityHeader = useTransform(scrollY, [actualStart, actualEnd], [0, 1]);
            const yText = useTransform(scrollY, [actualStart + 400, actualEnd], [20, 0]);
            const opacityText = useTransform(scrollY, [actualStart + 500, actualEnd + 200], [0, 1]);
            useEffect(() => {
                if (sessionsOnClient === null || sessionsOnClient === void 0 ? void 0 : sessionsOnClient.value) {
                    setSessions(sessionsOnClient.value);
                }
            }, [sessionsOnClient]);
            useEffect(() => {
                if (adminContent === null || adminContent === void 0 ? void 0 : adminContent.sessions) {
                    setSessions(adminContent.sessions);
                }
            }, [adminContent]);
            return (React.createElement("div", { className: classes.wrapper },
                React.createElement(Container, { ref: sessionBlockRef, maxWidth: "sm" },
                    React.createElement(motion.div, { style: isMobile
                            ? {
                                translateY: yHeader,
                                ["opacity"]: opacityHeader
                            }
                            : null },
                        React.createElement(Text, { className: classes.titleText, variant: "h2" }, block.titles[0])),
                    React.createElement(motion.div, { style: isMobile
                            ? {
                                translateY: yText,
                                ["opacity"]: opacityText
                            }
                            : null },
                        React.createElement(Text, { variant: "body1", className: classes.bodyText }, block.texts[0]))),
                React.createElement("div", { className: classes.cardWrapper },
                    React.createElement(motion.div, { style: { translateX: x }, className: classes.motionDiv }, sessions === null || sessions === void 0 ? void 0 : sessions.map((session, index) => {
                        return (React.createElement("div", { key: index, className: classes.card },
                            React.createElement(UpcomingSessionCard, { key: session.id, options: mapToCard({ session }), displayDateLabel: true, user: null, state: SessionState.Waiting, hideMeta: true })));
                    })))));
        };
        this.Compose = (props) => {
            const { block } = props;
            const { updateContent } = useContext(AdminCampaignContentContext);
            const titleOnChange = (event) => {
                block.titles[0] = event.target.value;
                updateContent(block);
            };
            const textOnChange = (event) => {
                block.texts[0] = event.target.value;
                updateContent(block);
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(AdminFormInput, { name: "title", label: "Title", onChange: titleOnChange, required: true, value: block.titles[0] }),
                React.createElement(AdminFormInput, { name: "text", label: "Text", onChange: textOnChange, required: true, value: block.texts[0] })));
        };
    }
}
//# sourceMappingURL=AnimatedSessionsBlock.js.map